//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Item from "./Item.vue";

const defPagItems = 6;

export default {
  name: "Pagination",
  components: { Item },
  data() {
    return {
      adjusting: false,
      debounceTimer: null,
      lastTotalPages: 0,
      lastHideCount: 0,
      lastActivePage: 0,
      pages: []
    };
  },
  computed: {
    reloading() {
      return this.$store.getters.reloading;
    },
    isAdjusting() {
      if (!this.options.transitionOnReload && this.options.preserveResults) return false;
      else return this.adjusting;
    },
    totalPages() {
      return this.$store.getters.results.totalPages;
    },
    currentPage() {
      return this.$store.getters.currentPage;
    },
    enablePrev() {
      return this.currentPage > 0;
    },
    enableNext() {
      return this.currentPage < this.totalPages - 1;
    },
    hideCount() {
      return this.$store.getters.results.totalPages - (this.$root.options.maxPaginationItems || defPagItems);
    },
    computedPages() {
      if (this.adjusting) return [];
      if (this.totalPages !== this.lastTotalPages || this.hideCount !== this.lastHideCount || this.currentPage !== this.lastActivePage) {
        this.lastTotalPages = this.totalPages;
        this.lastHideCount = this.hideCount;
        this.lastActivePage = this.currentPage;
        this.pages = [...Array(this.totalPages).keys()].filter((num, index) => {
          return this.getVisibilityAtIndex(num) || this.isEllipsis(num);
        }).map((num) => {
          return { 
            num: num + 1,
            index: num,
            isActive: this.isActive(num),
            isNumber: this.isNumber(num),
            isEllipsis: this.isEllipsis(num)
          }
        });
      }
      return this.pages;
    }
  },
  methods: {
    initializeHistory() {
      window.history.replaceState({ page: this.currentPage }, "");
      window.onpopstate = (e) => {
        this.$store.dispatch("goToPage", e.state.page);
      };
    },
    goToPage(index) {
      if (this.options.paginationUsesHistory) {
        window.history.pushState({ page: index }, "");
      }
      this.$store.dispatch("goToPage", index);
    },
    navigate(delta, event) {
      this.goToPage(this.currentPage + delta);
      if (event && event.target && event.detail > 0) {
        event.target.blur();
      }
    },
    isActive(index) {
      return index === this.currentPage;
    },
    isNumber(index) {
      return this.getVisibilityAtIndex(index);
    },
    isEllipsis(index) {
      return this.getVisibilityAtIndex(index - 1);
    },
    getVisibilityAtIndex(index) {
      let visible = true;
      if (this.hideCount > 0) {
        const delta = Math.floor(this.hideCount / 2);

        if (
          index == 0 ||
          index == this.currentPage ||
          index == this.totalPages - 1
        ) {
          return visible;
        }

        let middle = Math.floor(this.totalPages / 2);
        let leftStart = middle;
        let lowRange = middle - delta;

        let rightStart = middle;
        let highRange = middle + delta;
        let rangeOffset = 0;

        if (
          this.currentPage >= lowRange - 2 &&
          this.currentPage <= highRange + 2
        ) {
          middle = this.currentPage;
          leftStart = middle - 2;
          lowRange = leftStart - delta;

          rightStart = middle + 2;
          highRange = rightStart + delta;
        }

        if (highRange > this.totalPages)
          rangeOffset = this.totalPages - highRange;
        if (lowRange < 1) rangeOffset = Math.abs(1 - lowRange);

        lowRange = lowRange + rangeOffset;
        highRange = highRange + rangeOffset;

        if (index <= leftStart && index >= lowRange) visible = false;
        if (index >= rightStart && index <= highRange) visible = false;
      }
      return visible;
    },
  },
};
